/**
 * Get channel options for report filter
 * Only channels used with Desk are necessary
 */
export const getChannelOptions = () => {
    return [
        { id: 1, label: 'BLiP Chat', name: 'BLiP Chat', value: '0mn.io' },
        { id: 9, label: 'Apple Messages for Business', name: 'Apple Messages for Business', value: 'businesschat.gw.msging.net' },
        { id: 8, label: 'WhatsApp', name: 'WhatsApp', value: 'wa.gw.msging.net' },
        { id: 2, label: 'Messenger', name: 'Messenger', value: 'messenger.gw.msging.net' },
        { id: 3, label: 'Workplace', name: 'Workplace', value: 'workplace.gw.msging.net' },
        { id: 5, label: 'Telegram', name: 'Telegram', value: 'telegram.gw.msging.net' },
        { id: 6, label: 'E-mail', name: 'E-mail', value: 'mailgun.gw.msging.net' },
        { id: 10, label: 'Instagram', name: 'Instagram', value: 'instagram.gw.msging.net' },
    ];
};
